import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * @author Claude
 * @date 2025.11.03
 * @description 사이드바 토글 상태 관리 스토어
 */

type SidebarData = {
  isVisible: boolean;
};

type SidebarAction = {
  toggleSidebar: () => void;
  setSidebarVisible: (visible: boolean) => void;
};

export const useSidebarStore = create<SidebarData & SidebarAction>()(
  persist(
    (set) => ({
      // 상태
      isVisible: false,

      // 액션
      toggleSidebar: () => set((state) => ({ isVisible: !state.isVisible })),
      setSidebarVisible: (visible: boolean) => set({ isVisible: visible }),
    }),
    {
      name: 'sidebar-storage', // localStorage key
    }
  )
);